// assets/delivery-calendar.js
// Optimised: DOM reuse, event delegation, cached timestamps, partial updates on click.

(function () {
  'use strict';

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function parseIntOrNull(value) {
    if (value === undefined || value === null || value === '') return null;
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }

  // Always returns midnight local time — safe for getTime() comparisons.
  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDays(date, days) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    d.setDate(d.getDate() + days);
    return d;
  }

  function addMonths(date, months) {
    var d = new Date(date.getFullYear(), date.getMonth(), 1);
    d.setMonth(d.getMonth() + months);
    return d;
  }

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  function clampDateToMonthRange(date, minDate, maxDate) {
    var d = new Date(date.getFullYear(), date.getMonth(), 1);
    var minM = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var maxM = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
    if (d < minM) return minM;
    if (d > maxM) return maxM;
    return d;
  }

  function formatDateForCustomer(date) {
    if (!date) return '';
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
  }

  function toISODate(date) {
    return (
      date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0')
    );
  }

  function dateFromISO(str) {
    var p = str.split('-');
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }

  function createPdcBookingId() {
    return 'pdc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
  }

  function cartUrl(path) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + path;
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    if (
      window.DELIVERY_CALENDAR_CONFIG &&
      window.DELIVERY_CALENDAR_CONFIG.money_format &&
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(cents, window.DELIVERY_CALENDAR_CONFIG.money_format);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  var WEEKDAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var MONTH_NAMES = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  // ─── Core ───────────────────────────────────────────────────────────────────

  function initCalendar(container) {
    if (container.dataset.pdcInitialized === 'true') return;
    container.dataset.pdcInitialized = 'true';

    // Read data attributes
    var basePriceCents               = parseIntOrNull(container.dataset.basePrice);
    var priorityUpgradeVariantId     = container.dataset.priorityUpgradeVariantId || null;
    var priorityUpgradePriceCents    = parseIntOrNull(container.dataset.priorityUpgradePrice) || 0;
    var rushUpgradeVariantId         = container.dataset.rushUpgradeVariantId || null;
    var rushUpgradePriceCents        = parseIntOrNull(container.dataset.rushUpgradePrice) || 0;
    var seaUpgradeVariantId          = container.dataset.seaUpgradeVariantId || null;
    var seaUpgradePriceCents         = parseIntOrNull(container.dataset.seaUpgradePrice) || 0;

    var standardStartOffset  = parseIntOrNull(container.dataset.standardStartOffsetDays);
    var standardEndOffset    = parseIntOrNull(container.dataset.standardEndOffsetDays);
    var priorityStartOffset  = parseIntOrNull(container.dataset.priorityStartOffsetDays);
    var priorityEndOffset    = parseIntOrNull(container.dataset.priorityEndOffsetDays);
    var rushStartOffset      = parseIntOrNull(container.dataset.rushStartOffsetDays);
    var rushEndOffset        = parseIntOrNull(container.dataset.rushEndOffsetDays);
    var seaStartOffset       = parseIntOrNull(container.dataset.seaStartOffsetDays);
    var seaEndOffset         = parseIntOrNull(container.dataset.seaEndOffsetDays);

    // DOM refs
    var selectedEl   = container.querySelector('.delivery-calendar__selected');
    var windowInfoEl = container.querySelector('.delivery-calendar__window-info');
    var pricingEl    = container.querySelector('.delivery-calendar__pricing');
    var legendEl     = container.querySelector('.delivery-calendar__legend');
    var prevBtn      = container.querySelector('.delivery-calendar__nav--prev');
    var nextBtn      = container.querySelector('.delivery-calendar__nav--next');
    var monthEl      = container.querySelector('.delivery-calendar__month');
    var weekdaysEl   = container.querySelector('.delivery-calendar__weekdays');
    var gridEl       = container.querySelector('.delivery-calendar__grid');

    // Product form
    var productFormWrapper =
      container.closest('product-form') ||
      container.closest('form[action^="/cart/add"]') ||
      document.querySelector('product-form') ||
      document.querySelector('form[action^="/cart/add"]');

    if (!productFormWrapper) {
      console.warn('delivery-calendar: product form wrapper not found');
      return;
    }

    var productForm =
      productFormWrapper.tagName &&
      productFormWrapper.tagName.toLowerCase() === 'form'
        ? productFormWrapper
        : productFormWrapper.querySelector('form');

    if (!productForm) {
      console.warn('delivery-calendar: product form not found');
      return;
    }

    var addButton =
      productForm.querySelector('button[name="add"]') ||
      productForm.querySelector('[type="submit"]') ||
      productFormWrapper.querySelector('button[name="add"]') ||
      productFormWrapper.querySelector('[type="submit"]');

    if (!addButton) {
      console.warn('delivery-calendar: add button not found');
      return;
    }

    function getCurrentVariantId() {
      var input = productForm.querySelector('input[name="id"]');
      if (input && input.value) return input.value;
      var select = productForm.querySelector('select[name="id"]');
      if (select && select.value) return select.value;
      return null;
    }

    // Window config
    var windowsConfig = {
      standard: {
        key: 'standard',
        label: 'Standard',
        cartLabel: 'Standard',
        leadMinDays: standardStartOffset !== null ? standardStartOffset : 41,
        leadMaxDays: standardEndOffset   !== null ? standardEndOffset   : 90,
        surchargeCents: 0,
        visible: true
      },
      priority: {
        key: 'priority',
        label: 'Priority',
        cartLabel: 'Priority Build',
        leadMinDays: priorityStartOffset !== null ? priorityStartOffset : 21,
        leadMaxDays: priorityEndOffset   !== null ? priorityEndOffset   : 40,
        surchargeCents: priorityUpgradePriceCents || 0,
        visible: true
      },
      rush: {
        key: 'rush',
        label: 'Rush',
        cartLabel: 'Rush Build',
        leadMinDays: rushStartOffset !== null ? rushStartOffset : 10,
        leadMaxDays: rushEndOffset   !== null ? rushEndOffset   : 20,
        surchargeCents: rushUpgradePriceCents || 0,
        visible: true
      },
      sea: {
        key: 'sea',
        label: 'Sea',
        cartLabel: 'Sea Freight',
        leadMinDays: seaStartOffset !== null ? seaStartOffset : 21,
        leadMaxDays: seaEndOffset   !== null ? seaEndOffset   : 120,
        surchargeCents: seaUpgradePriceCents || 0,
        visible: container.dataset.showSea === 'true'
      }
    };

    var today    = startOfDay(new Date());
    var todayTs  = today.getTime();

    // ── Cache window timestamps once — no addDays() per cell per render ───────
    var windowTs = {};
    ['standard', 'priority', 'rush', 'sea'].forEach(function (key) {
      var cfg = windowsConfig[key];
      windowTs[key] = {
        start: addDays(today, cfg.leadMinDays).getTime(),
        end:   addDays(today, cfg.leadMaxDays).getTime()
      };
    });

    var minLead = Math.min(
      windowsConfig.standard.leadMinDays,
      windowsConfig.priority.leadMinDays,
      windowsConfig.rush.leadMinDays
    );
    var maxLead = Math.max(
      windowsConfig.standard.leadMaxDays,
      windowsConfig.priority.leadMaxDays,
      windowsConfig.rush.leadMaxDays
    );
    if (windowsConfig.sea.visible) {
      minLead = Math.min(minLead, windowsConfig.sea.leadMinDays);
      maxLead = Math.max(maxLead, windowsConfig.sea.leadMaxDays);
    }

    var fullMinDate = addDays(today, minLead);
    var fullMaxDate = addDays(today, maxLead);
    var fullMinTs   = fullMinDate.getTime();
    var fullMaxTs   = fullMaxDate.getTime();

    var fullMinMonth = new Date(fullMinDate.getFullYear(), fullMinDate.getMonth(), 1).getTime();
    var fullMaxMonth = new Date(fullMaxDate.getFullYear(), fullMaxDate.getMonth(), 1).getTime();

    // ── Fast window lookup using cached timestamps ────────────────────────────
    function getVisualWindowForTs(ts) {
      if (ts >= windowTs.rush.start     && ts <= windowTs.rush.end)     return 'rush';
      if (ts >= windowTs.priority.start && ts <= windowTs.priority.end) return 'priority';
      if (ts >= windowTs.standard.start && ts <= windowTs.standard.end) return 'standard';
      if (windowsConfig.sea.visible &&
          ts >= windowTs.sea.start  && ts <= windowTs.sea.end)          return 'sea';
      return null;
    }

    // ── State ─────────────────────────────────────────────────────────────────
    var selectedWindowKey = 'standard';
    var selectedDate      = null;
    var selectedTs        = null;
    var currentMonth      = null;

    // ── First date helpers ────────────────────────────────────────────────────
    function getFirstDateForWindow(key) {
      var cfg = windowsConfig[key];
      if (!cfg) return fullMinDate;

      var d = addDays(today, cfg.leadMinDays);
      var endTs = windowTs[key].end;

      while (d.getTime() <= endTs && d.getTime() <= fullMaxTs) {
        if (!isWeekend(d) && getVisualWindowForTs(d.getTime()) === key) return d;
        d = addDays(d, 1);
      }

      return addDays(today, cfg.leadMinDays);
    }

    // Init selected date
    selectedDate  = getFirstDateForWindow('standard');
    selectedTs    = selectedDate.getTime();
    currentMonth  = clampDateToMonthRange(selectedDate, fullMinDate, fullMaxDate);

    // ─── DOM pre-build ────────────────────────────────────────────────────────

    // Weekdays — built once with DocumentFragment
    if (weekdaysEl) {
      var wFrag = document.createDocumentFragment();
      WEEKDAY_NAMES.forEach(function (name) {
        var el = document.createElement('div');
        el.className = 'delivery-calendar__weekday';
        el.textContent = name;
        wFrag.appendChild(el);
      });
      weekdaysEl.appendChild(wFrag);
    }

    // Grid — pre-create 42 cells once, never destroy them ─────────────────────
    var cells = [];
    if (gridEl) {
      var gFrag = document.createDocumentFragment();
      for (var ci = 0; ci < 42; ci++) {
        var cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'delivery-calendar__day';
        gFrag.appendChild(cell);
        cells.push(cell);
      }
      gridEl.appendChild(gFrag);

      // ── Single delegated listener on grid instead of 42 per render ──────────
      gridEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.delivery-calendar__day');
        if (!btn || btn.disabled) return;

        var dateStr = btn.dataset.date;
        if (!dateStr) return;

        var d   = dateFromISO(dateStr);
        var ts  = d.getTime();
        var key = getVisualWindowForTs(ts);
        if (!key) return;

        selectedDate      = d;
        selectedTs        = ts;
        selectedWindowKey = key;

        updateCellSelection();
        updateTexts();
        updateLegendActiveState();
      });
    }

    // ─── Legend ───────────────────────────────────────────────────────────────

    function buildLegend() {
      if (!legendEl) return;
      legendEl.innerHTML = '';

      var entries = [
        { key: 'standard', cls: 'is-standard' },
        { key: 'priority', cls: 'is-priority' },
        { key: 'rush',     cls: 'is-rush'     },
        { key: 'sea',      cls: 'is-sea'      }
      ];

      var frag = document.createDocumentFragment();
      entries.forEach(function (entry) {
        var cfg = windowsConfig[entry.key];
        if (!cfg || !cfg.visible) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'delivery-calendar__pill ' + entry.cls;
        btn.textContent = cfg.label;
        btn.setAttribute('data-delivery-window', entry.key);
        btn.addEventListener('click', function () {
          setSelectedWindow(entry.key, true);
        });
        frag.appendChild(btn);
      });

      legendEl.appendChild(frag);
      updateLegendActiveState();
    }

    function updateLegendActiveState() {
      if (!legendEl) return;
      var pills = legendEl.querySelectorAll('.delivery-calendar__pill');
      pills.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-delivery-window') === selectedWindowKey);
      });
    }

    // ─── Calendar render ──────────────────────────────────────────────────────
    // Full re-render: runs on month navigation and initial load.
    // On date click we only run updateCellSelection() — much cheaper.

    function renderCalendar() {
      if (!gridEl) return;

      var year  = currentMonth.getFullYear();
      var month = currentMonth.getMonth();

      if (monthEl) {
        monthEl.textContent = MONTH_NAMES[month] + ' ' + year;
      }

      var firstWeekday = new Date(year, month, 1).getDay();
      var offset = (firstWeekday + 6) % 7; // Monday = 0

      for (var i = 0; i < 42; i++) {
        var cell    = cells[i];
        var dayNum  = i - offset + 1;
        var cellDate = new Date(year, month, dayNum);
        var cellTs  = cellDate.getTime();

        cell.textContent  = String(cellDate.getDate());
        cell.dataset.date = toISODate(cellDate);
        cell.disabled     = false;

        // Reset classes to base only
        cell.className = 'delivery-calendar__day';

        var inCurrentMonth =
          cellDate.getMonth() === month && cellDate.getFullYear() === year;

        if (!inCurrentMonth) cell.classList.add('is-adjacent-month');

        var windowKey = getVisualWindowForTs(cellTs);
        if (windowKey) cell.classList.add('is-window-' + windowKey);

        var weekend = isWeekend(cellDate);
        if (weekend) cell.classList.add('is-weekend');

        var disabled = cellTs < fullMinTs || cellTs > fullMaxTs || !windowKey || weekend;
        if (disabled) {
          cell.disabled = true;
          cell.classList.add('is-disabled');
        }

        if (cellTs === selectedTs) {
          cell.classList.add('is-selected');
        }

        if (cellTs === todayTs) {
          cell.classList.add('is-today');
        }
      }

      // Nav buttons
      if (prevBtn) {
        var prevMonthTs = new Date(year, month - 1, 1).getTime();
        prevBtn.disabled = prevMonthTs < fullMinMonth;
      }
      if (nextBtn) {
        var nextMonthTs = new Date(year, month + 1, 1).getTime();
        nextBtn.disabled = nextMonthTs > fullMaxMonth;
      }
    }

    // Partial update — only toggle is-selected on cells.
    // Runs on date click: ~2 class operations vs 42 DOM rebuilds.
    function updateCellSelection() {
      for (var i = 0; i < 42; i++) {
        var cell    = cells[i];
        var dateStr = cell.dataset.date;
        if (!dateStr) continue;

        var isNowSelected = dateFromISO(dateStr).getTime() === selectedTs;
        var wasSelected   = cell.classList.contains('is-selected');

        if (wasSelected !== isNowSelected) {
          cell.classList.toggle('is-selected', isNowSelected);
        }
      }
    }

    // ─── Window switching ─────────────────────────────────────────────────────

    function setSelectedWindow(key, moveDateToWindow) {
      if (!windowsConfig[key]) return;
      selectedWindowKey = key;

      if (moveDateToWindow) {
        var newDate    = getFirstDateForWindow(key);
        selectedDate   = newDate;
        selectedTs     = newDate.getTime();

        var newMonthTs = new Date(newDate.getFullYear(), newDate.getMonth(), 1).getTime();
        var curMonthTs = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1).getTime();

        if (newMonthTs !== curMonthTs) {
          // Month changed → full re-render
          currentMonth = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
          renderCalendar();
        } else {
          // Same month → just update selection classes
          updateCellSelection();
        }
      } else {
        updateCellSelection();
      }

      updateTexts();
      updateLegendActiveState();
    }

    // ─── Text / pricing panel ─────────────────────────────────────────────────

    function updateTexts() {
      if (!selectedDate || !selectedWindowKey) {
        if (selectedEl)   selectedEl.textContent = 'No date selected yet.';
        if (windowInfoEl) windowInfoEl.innerHTML  = '';
        if (pricingEl)    pricingEl.textContent   = '';
        return;
      }

      var cfg = windowsConfig[selectedWindowKey];

      if (selectedEl) {
        selectedEl.innerHTML =
          'Selected date: <strong>' + formatDateForCustomer(selectedDate) + '</strong>';
      }

      if (windowInfoEl) windowInfoEl.innerHTML = '';

      if (!pricingEl || !basePriceCents) return;

      var totalCents = basePriceCents + (cfg.surchargeCents || 0);

      var html =
        'Total with <strong>' + cfg.label + '</strong>: <strong>' +
        formatMoney(totalCents) + '</strong>. ';

      if (cfg.surchargeCents && cfg.surchargeCents > 0) {
        html += 'Includes a <strong>' + formatMoney(cfg.surchargeCents) + '</strong> speed upgrade.';
      } else if (selectedWindowKey === 'standard') {
        html += 'No extra production fee applies.';
      } else {
        html += 'The upgrade product or price is not configured yet.';
      }

      pricingEl.innerHTML = html;
    }

    // ─── Month navigation ─────────────────────────────────────────────────────

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var prev    = addMonths(currentMonth, -1);
        var prevTs  = new Date(prev.getFullYear(), prev.getMonth(), 1).getTime();
        if (prevTs < fullMinMonth) return;
        currentMonth = prev;
        renderCalendar();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var next   = addMonths(currentMonth, 1);
        var nextTs = new Date(next.getFullYear(), next.getMonth(), 1).getTime();
        if (nextTs > fullMaxMonth) return;
        currentMonth = next;
        renderCalendar();
      });
    }

    // ─── Cart submission ──────────────────────────────────────────────────────

    function pushSpeedUpgradeItem(items, selectedKey, variantId, bookingId) {
      var upgradeVariantId = null;
      var windowLabel      = '';

      if (selectedKey === 'priority' && priorityUpgradeVariantId) {
        upgradeVariantId = priorityUpgradeVariantId;
        windowLabel = 'Priority Build';
      } else if (selectedKey === 'rush' && rushUpgradeVariantId) {
        upgradeVariantId = rushUpgradeVariantId;
        windowLabel = 'Rush Build';
      } else if (selectedKey === 'sea' && seaUpgradeVariantId) {
        upgradeVariantId = seaUpgradeVariantId;
        windowLabel = 'Sea Freight';
      }

      if (!upgradeVariantId) return;

      items.push({
        id: Number(upgradeVariantId),
        quantity: 1,
        properties: {
          _pdc_item_type:                'production_speed_upgrade',
          _pdc_booking_id:               bookingId,
          _pdc_upgrade_for:              String(variantId),
          _pdc_production_window:        selectedKey,
          _pdc_production_window_label:  windowLabel
        }
      });
    }

    var isSubmitting = false;

    function resetSubmitState() {
      isSubmitting = false;
      if (addButton) {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('is-loading');
        addButton.setAttribute('aria-disabled', 'false');
      }
    }

    function handleAdd(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      }

      if (isSubmitting) return false;
      isSubmitting = true;

      if (addButton) {
        addButton.setAttribute('disabled', 'disabled');
        addButton.setAttribute('aria-disabled', 'true');
        addButton.classList.add('is-loading');
      }

      var variantId = getCurrentVariantId();
      if (!variantId) {
        alert('Please select a product variant first.');
        resetSubmitState();
        return false;
      }

      if (!selectedDate || !selectedWindowKey) {
        alert('Please choose a delivery date before adding to cart.');
        if (container.scrollIntoView) {
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        resetSubmitState();
        return false;
      }

      var cfg                    = windowsConfig[selectedWindowKey];
      var dateISO                = toISODate(selectedDate);
      var customerDeliveryDate   = formatDateForCustomer(selectedDate);
      var bookingId              = createPdcBookingId();

      var standardFallback         = getFirstDateForWindow('standard');
      var standardFallbackISO      = toISODate(standardFallback);
      var standardFallbackFormatted = formatDateForCustomer(standardFallback);

      var items = [{
        id: Number(variantId),
        quantity: 1,
        properties: {
          'Delivery date':                    customerDeliveryDate,
          'Delivery option':                  cfg.cartLabel || cfg.label,
          _pdc_booking_id:                    bookingId,
          _pdc_delivery_option:               selectedWindowKey,
          _pdc_standard_delivery_date:        standardFallbackISO,
          _pdc_standard_delivery_date_formatted: standardFallbackFormatted,
          _pdc_original_delivery_date:        dateISO,
          _pdc_original_delivery_date_formatted: customerDeliveryDate,
          _pdc_original_delivery_option:      selectedWindowKey,
          _pdc_original_delivery_option_label: cfg.cartLabel || cfg.label
        }
      }];

      pushSpeedUpgradeItem(items, selectedWindowKey, variantId, bookingId);

      fetch(cartUrl('/cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.text().then(function (text) {
              throw new Error(text || 'Cart request failed');
            });
          }
          return res.json();
        })
        .then(function () {
          window.location.href = cartUrl('/cart');
        })
        .catch(function (err) {
          console.error(err);
          alert('Something went wrong while adding this configuration to your cart. Please try again.');
          resetSubmitState();
        });

      return false;
    }

    productForm.addEventListener('submit', handleAdd, true);
    addButton.addEventListener('click', handleAdd, true);

    // ─── Init ─────────────────────────────────────────────────────────────────

    buildLegend();
    renderCalendar();
    updateTexts();
  }

  // ─── Boot (must be AFTER all variable and function definitions) ─────────────

  function bootDeliveryCalendars() {
    var containers = document.querySelectorAll('.delivery-calendar');
    if (!containers.length) return;
    containers.forEach(initCalendar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDeliveryCalendars, { once: true });
  } else {
    bootDeliveryCalendars();
  }

})();